



























import { fixRemittance } from '@/api/Remittances/remittances.api'
import ActionButton from '@/components/ActionButton.vue'
import CreateDialog from '@/components/CreateDialog.vue'
import { Step } from '@/utils/interfaces'
import { Remittance } from '@/utils/interfaces/remittance.interface'
import Vue, { PropType } from 'vue'
import ClientDestinyForm from './ClientDestinyForm.vue'

export default Vue.extend({
  components: { CreateDialog, ActionButton, ClientDestinyForm },
  props: {
    remittance: Object as PropType<Remittance>,
  },
  data() {
    return {
      model: false,
      loading: false,
    }
  },
  methods: {
    async onSuccess() {
      try {
        this.loading = true
        const response: any = await (this.$refs.form as Step).onNext()
        if (response) {
          await fixRemittance(this.remittance.remittance, {
            client_destiny: response,
          })
          this.$emit('new-client')
          this.model = false
        }
      } finally {
        this.loading = false
      }
    },
  },
})
